module.exports = __webpack_public_path__ + "img/media.603efd43.png";